module.exports = __webpack_public_path__ + "static/developers-509ae14bbd62d5e0a576181ef6dfe45d.mp4";